module.exports = wphtmlmailwebfonts;